import React, { createContext, useState } from 'react';

interface NavigationContextType {
  isNavOpen: boolean;
  setIsNavOpen: (isOpen: boolean) => void;
  dragTransform: string | undefined;
  setDragTransform: (transform: string | undefined) => void;
}

export const NavigationContext = createContext<NavigationContextType>({
  isNavOpen: false,
  setIsNavOpen: () => {},
  dragTransform: undefined,
  setDragTransform: () => {},
});

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [dragTransform, setDragTransform] = useState<string | undefined>(undefined);

  return (
    <NavigationContext.Provider value={{ isNavOpen, setIsNavOpen, dragTransform, setDragTransform }}>
      {children}
    </NavigationContext.Provider>
  );
};
